import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterMenuSearch = () => {
  const menuSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-menu/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { menuSearch }
}

export default InteractorMasterMenuSearch
